export default {
  'form-step-form.basic.title': '基础表单',
  'form-step-form.basic.description':
    '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',

  'form-step-form.email.required': '请输入邮箱地址！',
  'form-step-form.email.wrong-format': '邮箱地址格式错误！',
  'form-step-form.userName.required': '请输入用户名!',
  'form-step-form.password.required': '请输入密码！',
  'form-step-form.password.twice': '两次输入的密码不匹配!',
  'form-step-form.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'form-step-form.strength.strong': '强度：强',
  'form-step-form.strength.medium': '强度：中',
  'form-step-form.strength.short': '强度：太短',
  'form-step-form.confirm-password.required': '请确认密码！',
  'form-step-form.phone-number.required': '请输入手机号！',
  'form-step-form.phone-number.wrong-format': '手机号格式错误！',
  'form-step-form.verification-code.required': '请输入验证码！',
  'form-step-form.title.required': '请输入标题',
  'form-step-form.date.required': '请选择起止日期',
  'form-step-form.goal.required': '请输入目标描述',
  'form-step-form.standard.required': '请输入衡量标准',

  'form-step-form.form.get-captcha': '获取验证码',
  'form-step-form.captcha.second': '秒',
  'form-step-form.form.optional': '（选填）',
  'form-step-form.form.submit': '提交',
  'form-step-form.form.save': '保存',
  'form-step-form.email.placeholder': '邮箱',
  'form-step-form.password.placeholder': '至少6位密码，区分大小写',
  'form-step-form.confirm-password.placeholder': '确认密码',
  'form-step-form.phone-number.placeholder': '手机号',
  'form-step-form.verification-code.placeholder': '验证码',
  'form-step-form.title.label': '标题',
  'form-step-form.title.placeholder': '给目标起个名字',
  'form-step-form.date.label': '起止日期',
  'form-step-form.placeholder.start': '开始日期',
  'form-step-form.placeholder.end': '结束日期',
  'form-step-form.goal.label': '目标描述',
  'form-step-form.goal.placeholder': '请输入你的阶段性工作目标',
  'form-step-form.standard.label': '衡量标准',
  'form-step-form.standard.placeholder': '请输入衡量标准',
  'form-step-form.client.label': '客户',
  'form-step-form.label.tooltip': '目标的服务对象',
  'form-step-form.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'form-step-form.invites.label': '邀评人',
  'form-step-form.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'form-step-form.weight.label': '权重',
  'form-step-form.weight.placeholder': '请输入',
  'form-step-form.public.label': '目标公开',
  'form-step-form.label.help': '客户、邀评人默认被分享',
  'form-step-form.radio.public': '公开',
  'form-step-form.radio.partially-public': '部分公开',
  'form-step-form.radio.private': '不公开',
  'form-step-form.publicUsers.placeholder': '公开给',
  'form-step-form.option.A': '同事甲',
  'form-step-form.option.B': '同事乙',
  'form-step-form.option.C': '同事丙',
};
